var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.23624 8.00005L10.8405 14.1341C11.0431 14.3221 11.0541 14.6391\n  10.8656 14.8411C10.6771 15.0421 10.3593 15.0541 10.1567 14.8661L3.15942 8.36605C3.05715 8.27105 3 8.13905 3 8.00005C3\n  7.86105 3.05715 7.72905 3.15942 7.63405L10.1567 1.13105C10.254 1.04105 10.3763 0.997052 10.4986 0.997052C10.633\n  0.997052 10.7673 1.05005 10.8656 1.15605C11.0541 1.35805 11.0431 1.67405 10.8405 1.86205L4.23624 8.00005Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
